import { InjectionKey } from 'vue'
import { GeoImagesViewModel } from '../models/GeoImages.viewmodel'

export const GeoImagesViewModelKey: InjectionKey<GeoImagesViewModel> = Symbol('GeoImagesViewModel')
